var _path, _path2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurvas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 13.8889C3.34667 14.837 3.08889 16.358 3 17H21C20.2889 15.963 18.7333 13.7704 18.2 13.2963C17.5333 12.7037 15.5333 11.0741 15.1333 10.3333C14.8133 9.74074 14.2 8.50617 13.9333 7.96296C13.6222 6.97531 12.6533 5 11.2667 5C9.88 5 9 6.67901 8.73333 7.51852C8.55556 8.06173 8.09333 9.2963 7.66667 9.88889C7.13333 10.6296 6.6 10.6296 5.93333 11.0741C5.26667 11.5185 4.06667 12.7037 3.66667 13.8889Z",
    fill: "#ABADB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93359 17V11.0739C6.16012 10.9229 6.37126 10.8232 6.57223 10.7283C6.9626 10.544 7.31464 10.3778 7.66667 9.88889C8.09333 9.2963 8.55556 8.06173 8.73333 7.51852C9 6.67901 9.88 5 11.2667 5C12.6533 5 13.6222 6.97531 13.9333 7.96296C14.2 8.50617 14.8133 9.74074 15.1333 10.3333C15.3931 10.8144 16.3277 11.6703 17.1336 12.3736V17H5.93359Z",
    fill: "#797D8D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 21,
    x2: -8.74228e-8,
    y2: 21,
    stroke: "#00D084",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvas);
export default __webpack_public_path__ + "static/media/curvas.b45094dea36c55a52d5048b8006d5bbb.svg";
export { ForwardRef as ReactComponent };